import { loadRouteLocation } from "vue-router";
import { defineNuxtPlugin, useRoute, useRouter } from "#app";
import { computed, shallowRef } from "#imports";
export const DEBUG = import.meta.dev && import.meta.client && import.meta.env.VITE_PAGES_PLUS_DEBUG;
export default defineNuxtPlugin(async (nuxt) => {
  const router = useRouter();
  let routesStackSizeMap = {};
  const historyState = shallowRef();
  const stacks = computed(() => {
    const currentStatueId = historyState.value?.id;
    if (!currentStatueId)
      return;
    return routesStackSizeMap[currentStatueId];
  });
  nuxt.hook("app:mounted", () => {
    router.beforeResolve(async () => {
      if (history.state.backgroundView)
        await loadRouteLocation(router.resolve(history.state.backgroundView));
    });
    router.afterEach(() => {
      historyState.value = history.state;
    });
  });
  const backgroundRoute = computed(() => {
    if (historyState.value?.backgroundView) {
      return router.resolve(historyState.value?.backgroundView);
    } else {
      return void 0;
    }
  });
  const route = computed(() => backgroundRoute.value || useRoute());
  async function backgroundNavigate(action, to, backgroundView) {
    const state = { id: `plus-${Date.now()}`, backgroundView };
    const _to = {
      ...typeof to === "string" ? { path: to } : to,
      state
    };
    if (action === "replace") {
      routesStackSizeMap[state.id] = stacks.value ?? [0];
      return router.replace(_to);
    } else if (action === "push") {
      const newStack = [...stacks.value ?? [0]];
      newStack.push((newStack.pop() ?? 0) + 1);
      routesStackSizeMap[state.id] = newStack;
      return router.push(_to);
    } else if (action === "push_open") {
      routesStackSizeMap[state.id] = [...stacks.value ?? [], 1];
      return router.push(_to);
    }
  }
  function push(to, open = false) {
    if (!historyState.value?.backgroundView) {
      routesStackSizeMap = {};
      return backgroundNavigate(open ? "push_open" : "push", to, router.currentRoute.value.fullPath);
    }
    return backgroundNavigate(open ? "push_open" : "push", to, historyState.value.backgroundView);
  }
  function replace(to) {
    if (!historyState.value?.backgroundView)
      return router.replace(to);
    return backgroundNavigate("replace", to, historyState.value.backgroundView);
  }
  function close(allOpened = false) {
    function getAllStackSize() {
      return (stacks.value ?? []).reduce((acc, cur) => acc + cur, 0);
    }
    function getCurrentStackSize() {
      return (stacks.value ?? [0]).slice(-1)[0];
    }
    const size = allOpened ? getAllStackSize() : getCurrentStackSize();
    if (DEBUG)
      console.log("close modal stack size:", size, `(all stacks: ${allOpened})`);
    if (size > 0)
      router.go(-size);
    else
      router.back();
  }
  return {
    provide: {
      modalRouter: {
        route,
        backgroundRoute,
        stacks,
        close,
        push,
        replace
      }
    }
  };
});
